import React, { useState } from "react";
import "./capture.css";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import CaptureDetails from "./capture-details";
import CaptureForm from "./capture-form";
import axios from "axios";
import Swal from "sweetalert2";
import { FaSpinner } from "react-icons/fa";

function Capture() {
  const [masterValue, setMasterValue] = useState("");
  const [view, setView] = useState("input");
  const [error, setError] = useState(""); // Estado para manejar errores
  const [masterData, setMasterData] = useState(null);
  const [autoSearch, setAutoSearch] = useState(false);

  const mockData = ["111-12345678", "222-87654321"];

  const handleInputChange = (e) => {
    let value = e.target.value; // Permitimos letras y números

    if (value.length > 3 && value[3] !== "-") {
      value = value.slice(0, 3) + "-" + value.slice(3);
    }

    setMasterValue(value);
    if (error) setError(""); // Borra el error cuando el usuario escribe
  };

  const handleGetInsumo = () => {
    alert(`Ejecucion realizada con exito.`);
  };

  const handleSearch = async () => {
    document.getElementById("btn_search").classList.add("d-none");
    document.getElementById("spinners").classList.remove("d-none");

    if (!masterValue.trim()) {
      // Verifica si el input está vacío
      setError("Este campo es obligatorio");
      document.getElementById("btn_search").classList.remove("d-none");
      document.getElementById("spinners").classList.add("d-none");
      return;
    }
    try {
      const master = masterValue;
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_capture/getMaster`,
        {
          params: { master },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code == 1) {
        setMasterData(res.data);
        if (res.data.data.expMaster != null) {
          if (!res.data.data.is_completed) {
            //aun no se completa
            document.getElementById("btn_search").classList.remove("d-none");
            document.getElementById("spinners").classList.add("d-none");
            setView("form");
          } else {
            //console.log('completa')
            document.getElementById("btn_search").classList.remove("d-none");
            document.getElementById("spinners").classList.add("d-none");
            setView("details");
          }
        } else {
          document.getElementById("btn_search").classList.remove("d-none");
          document.getElementById("spinners").classList.add("d-none");
          setView("form");
        }
      } else {
        console.log(res);
        document.getElementById("btn_search").classList.remove("d-none");
        document.getElementById("spinners").classList.add("d-none");
        Swal.fire("Error", "Master no encontrada, favor de verificar", "error");
      }
    } catch (error) {
      document.getElementById("btn_search").classList.remove("d-none");
      document.getElementById("spinners").classList.add("d-none");
      Swal.fire("Error", "Error. Intente nuevamente", "error");
    }
  };

  const handleSuccessFromChild = (masterId) => {
    setMasterValue(masterId); // actualiza el input
    setTimeout(() => {
      setView("input");
      handleSearch(); // luego lanza búsqueda con el nuevo valor
    }, 0);
  };

  return (
    <>
      <Helmet>
        <title>Horus | Búsqueda master</title>
      </Helmet>
      <ScrollToTop />
      <div className="container-fluid">
        {view === "input" && (
          <div className="row justify-content-center">
            <div className="col-6">
              <label for="inputMaster" class="amc-label">
                Master
              </label>
              <input
                type="text"
                class="form-control"
                id="inputMaster"
                value={masterValue}
                onChange={handleInputChange}
              />
              {error && <small className="text-danger">{error}</small>}
              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" onClick={handleGetInsumo}>
                  Obtener insumo
                </button>
                <FaSpinner className="spin d-none" id="spinners" />
                <button className="btnn" onClick={handleSearch} id="btn_search">
                  Buscar
                </button>
              </div>
            </div>
          </div>
        )}

        {view === "details" && (
          <CaptureDetails
            onSuccess={handleSuccessFromChild}
            masterData={masterData}
          />
        )}
        {view === "form" && (
          <CaptureForm
            onSuccess={handleSuccessFromChild}
            masterData={masterData}
          />
        )}
      </div>
    </>
  );
}

export default Capture;
